<template>
  <div class="title">
    <div class="main">
      {{title.main}}
    </div>
    <div class="sub">
      <div v-for="s in title.sub">
      {{s}}
      </div>
    </div>
  </div>
</template>

<script>
 export default {
   name: 'FPTitle',
   props: [ 'title'],
   computed: {
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .title {
   color: white;
   display: flex;
   flex-direction: column;
   justify-content: space-between;
   align-items: center;
   margin-top:10.42vw;
 }
 .title .main{
   font-size: 6vw;
   letter-spacing: 0.3vw;
   font-family: "Noto Sans SC", SourceHanSansCN-Bold;
   font-weight:bold;
   background:linear-gradient(to right,rgba(57,160,255,1), rgba(0,223,213,1));
   -webkit-background-clip:text;
   -webkit-text-fill-color:transparent;
 }
 .title .sub{
   font-size: 4.96vw;
   letter-spacing:0.3vh;
   font-family:SourceHanSansCN-Medium;
   font-weight: 800;
   display: flex;
   /* flex-direction: column; */
   align-items:center;
   justify-content:center;
   margin-top: 4vh;
 }

</style>
